const MULTI_VALUE_FIELD_TYPES = new Set(['checkbox', 'multiselect', 'multi-select']);
const SINGLE_VALUE_FIELD_TYPES = new Set(['radio', 'select', 'dropdown']);

const resolveOptionLabel = (value, options = []) => {
  const option = options?.find((candidate) =>
    typeof candidate === 'object'
      ? candidate?.value === value || candidate?.label === value
      : candidate === value
  );

  return option && typeof option === 'object'
    ? option?.label ?? String(value)
    : String(value);
};

export const formatSubmissionFieldValue = (
  key,
  value,
  formElements,
  { jsonSpacing } = {}
) => {
  const field = formElements?.find((element) => element?.name === key || element?.id === key);

  if (field?.type === 'toggle') {
    const isOn = value === true || value === 'true';
    return isOn ? (field.onLabel || 'On') : (field.offLabel || 'Off');
  }

  if (field?.type === 'slider') {
    const unit = field.sliderUnit || '';
    return unit ? `${value} ${unit}` : String(value);
  }

  if (Array.isArray(value) && MULTI_VALUE_FIELD_TYPES.has(field?.type)) {
    return value?.map((item) => resolveOptionLabel(item, field?.options))?.join(', ');
  }

  if (!Array.isArray(value) && SINGLE_VALUE_FIELD_TYPES.has(field?.type)) {
    return resolveOptionLabel(value, field?.options);
  }

  if (typeof value === 'object') return JSON.stringify(value, null, jsonSpacing);
  return String(value ?? '');
};